import { render, staticRenderFns } from "./IcoGear.vue?vue&type=template&id=60db9f8a"
import script from "./IcoGear.vue?vue&type=script&lang=js"
export * from "./IcoGear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports